// Minimal frontend port of the backend partner-campaign catalog
// (apps/saas_back/src/utils/partnerCampaigns/catalog.ts). Per repo convention the small mapping is
// duplicated instead of introducing a shared libs/* package; keep it in sync with the backend catalog.

export type PartnerOrigin = 'buk' | 'copec' | 'jetsmart';

interface PartnerCampaignEntry {
  partnerOrigin: PartnerOrigin;
  source: string;
  legacySource: string;
}

export const PARTNER_ORIGIN_LABELS: Record<PartnerOrigin, string> = {
  buk: 'Buk',
  copec: 'Copec',
  jetsmart: 'JetSMART',
};

export const PARTNER_ORIGINS: PartnerOrigin[] = ['buk', 'copec', 'jetsmart'];

const PARTNER_CAMPAIGNS: PartnerCampaignEntry[] = [
  { partnerOrigin: 'buk', source: 'buk-creditos', legacySource: 'BUK' },
  { partnerOrigin: 'buk', source: 'buk-cashback', legacySource: 'buk-cashback' },
  { partnerOrigin: 'buk', source: 'buk-estanque', legacySource: 'buk-estanque-copec' },
  { partnerOrigin: 'copec', source: 'copec-tarjeta', legacySource: 'alianza-copec' },
  { partnerOrigin: 'jetsmart', source: 'jetsmart-cashback', legacySource: 'jetsmart' },
];

// Matches a stored key exactly or with a paid-channel suffix (`buk-cashback-GoogleAds`).
const matchesKey = (source: string, key: string): boolean => source === key || source.startsWith(`${key}-`);

export interface PartnerMatch {
  partnerOrigin: PartnerOrigin;
  source: string;
  label: string;
}

// Mirror of the backend `findPartnerCampaignBySource`: matches the canonical and legacy keys and
// tolerates the paid-channel suffixes the webpage branch appends.
export const findPartnerBySource = (source: string | null | undefined): PartnerMatch | null => {
  if (!source) return null;
  const campaign = PARTNER_CAMPAIGNS.find(
    (entry) => matchesKey(source, entry.source) || matchesKey(source, entry.legacySource)
  );
  if (!campaign) return null;
  return {
    partnerOrigin: campaign.partnerOrigin,
    source: campaign.source,
    label: PARTNER_ORIGIN_LABELS[campaign.partnerOrigin],
  };
};
